import { jsx as e } from "react/jsx-runtime";
//#region src/IconMaterialDesignCheckBoxFilled.tsx
function t(t) {
	return /* @__PURE__ */ e("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		...t,
		children: /* @__PURE__ */ e("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z",
			clipRule: "evenodd"
		})
	});
}
t.displayName = "IconMaterialDesignCheckBoxFilled";
//#endregion
export { t as default };

//# sourceMappingURL=IconMaterialDesignCheckBoxFilled.js.map